

  import {defineComponent} from "vue";
  import router from "@/router";
  import {mapGetters, mapMutations, mapState} from "vuex";
  import paycoUtils from '@/assets/js/utils'

  import PopupComponent from '@/components/shared/PopupComponent.vue';
  import Receiver from '@/domain/receiver/Receiver';
  import api from "@/api/backend-api";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import Product from "@/domain/product/Product";

  export default defineComponent({
    name: "ReceiverSelection",
    components: {
      HeaderComponent,
      PopupComponent
    },
    data() {
      return {
        giftReceiverLimitCount: 0 as number,
        inputPhoneNumber: "" as string,
        duplicatePhoneNumber:"" as string,

        showAlreadyAddedPhoneNumberPopup: false,
        showInvalidPhoneNumberPopup: false,
        showGiftReceiverLimitPopup: false,

        showOpenContactsAppButton: false,

        showReceiverInput: true,
        isTypingMode: false,
        isDelBtn: false,
        isAndroid: false,
        isKeyupEvent: false,
      }
    },
    mounted() {
      this.isAndroid = paycoUtils.isAndroid();
      (this.$refs.phoneNumber as HTMLElement).autofocus = true;
      (this.$refs.phoneNumber as HTMLElement).focus();

      if (this.isApp) {
        this.showOpenContactsAppButton = true;
        if(paycoUtils.isAndroid()) {
          // 안드로이드
          document.addEventListener('message', this.receiveContactsFromArtiseeApp);
        } else if(paycoUtils.isIOS()) {
          // iOS
          window.addEventListener('message', this.receiveContactsFromArtiseeApp);
        }
      }

      window.vm.receiverSelectionComponent = this;
      api.getGiftReceiverLimit(this.product.productId)
      .then(response => {
        this.giftReceiverLimitCount = response.data.result.giftReceiverLimitCount;
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    beforeUnmount(): void {
      if(paycoUtils.isAndroid()) {
        // 안드로이드
        document.removeEventListener('message', this.receiveContactsFromArtiseeApp);
      } else if(paycoUtils.isIOS()) {
        // iOS
        window.removeEventListener('message', this.receiveContactsFromArtiseeApp);
      }
    },
    computed: {
      hasInputPhoneNumber(): boolean {
        return this.inputPhoneNumber.length > 0;
      },
      hasValidLength(): boolean {
        return this.inputPhoneNumber.length >= 10;
      },
      showDimmed(): boolean {
        return this.showInvalidPhoneNumberPopup || this.showAlreadyAddedPhoneNumberPopup || this.showGiftReceiverLimitPopup;
      },
      ...mapState({
        product: (state: any) => new Product(state.ProductStore.product),
        receivers: (state: any) => state.ReceiverStore.receivers.map((receiver: Receiver) => new Receiver(receiver)),
      }),
      ...mapGetters('ReceiverStore', [
        'hasReceiver'
      ]),
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    },
    methods: {
      addNewReceiver(): void {
        const newReceiver: Receiver = new Receiver({
          receiverTelNo: this.inputPhoneNumber,
          ticketCount: 1
        });

        if (!this.hasInputPhoneNumber) {
          (this.$refs.phoneNumber as HTMLElement).autofocus = false;
          (this.$refs.phoneNumber as HTMLElement).blur();
          return;
        }

        if (this.receivers.length + 1 > this.giftReceiverLimitCount) {
          this.toggleGiftReceiverLimitPopup();
          return;
        }

        if (!newReceiver.isValidPhoneNumber) {
          this.toggleInvalidPhoneNumberPopup();
          return;
        }

        if (this.isAddedReceiver(newReceiver)) {
          this.duplicatePhoneNumber = newReceiver.receiverTelNo;
          this.toggleAlreadyAddedPhoneNumberPopup();
          return;
        }

        this.addReceiver(newReceiver);
        this.showReceiverInput = false;
        this.inputPhoneNumber = "";
        this.isDelBtn = false;
        this.isTypingMode = false;
        (this.$refs.phoneNumber as HTMLElement).autofocus = false;
        (this.$refs.phoneNumber as HTMLElement).blur();
      },
      isAddedReceiver(newReceiver: Receiver): boolean {
        return this.receivers.some((receiver: Receiver) => {
          return receiver.receiverTelNo === newReceiver.receiverTelNo;
        });
      },
      clearInputPhoneNumber(): void {
        this.isDelBtn = true;
        this.inputPhoneNumber = "";
      },
      toggleInvalidPhoneNumberPopup(): void {
        this.showInvalidPhoneNumberPopup = !this.showInvalidPhoneNumberPopup;
        if(this.showInvalidPhoneNumberPopup === false) {
          (this.$refs.phoneNumber as HTMLElement).autofocus = true;
          (this.$refs.phoneNumber as HTMLElement).focus();
        }
      },
      toggleAlreadyAddedPhoneNumberPopup(): void {
        this.showAlreadyAddedPhoneNumberPopup = !this.showAlreadyAddedPhoneNumberPopup;
        if(this.showAlreadyAddedPhoneNumberPopup === false) {
          (this.$refs.phoneNumber as HTMLElement).autofocus = true;
          (this.$refs.phoneNumber as HTMLElement).focus();
        }
      },
      toggleGiftReceiverLimitPopup(): void {
        this.showGiftReceiverLimitPopup = !this.showGiftReceiverLimitPopup;
      },

      // 페이코 앱 연락처 연동을 위한 테스트 함수
      fetchAddress() {
        if(paycoUtils.isAndroid()) {
          // 안드로이드
          const message = {
            'action': 'callAddressbook',
            'callBackFunctionName': 'window.vm.receiverSelectionComponent.receiveContactsFromAOSApp'
          };

          (window as any).Android.nativeAppCaller(JSON.stringify(message));
        } else if(paycoUtils.isIOS()) {
          // iOS
          const message = {
            'action': 'callAddressbook',
            'callBackFunctionName': 'window.vm.receiverSelectionComponent.receiveContactsFromIOSApp'
          };

          (window as any).webkit.messageHandlers.natviceAppCaller.postMessage(message);
        }
      },
      receiveContactsFromIOSApp(contactList: Array<Address>) {
        alert(contactList[0].name);
        alert(this.removeHyphen(contactList[0].phonenumber));

        contactList.forEach(contact => {
          this.addReceiver(new Receiver({
            receiverName: contact.name,
            receiverTelNo: this.removeHyphen(contact.phonenumber),
            ticketCount: 1,
          }));
        });
      },
      receiveContactsFromAOSApp(contactData: string) {
        const contact = JSON.parse(contactData);
        alert(contact.name);
        alert(this.removeHyphen(contact.phoneNumber));

        this.addReceiver(new Receiver({
          receiverName: contact.name,
          receiverTelNo: this.removeHyphen(contact.phoneNumber),
          ticketCount: 1,
        }));
      },

      // 아티제 앱 연락처 연동을 위한 테스트 함수
      openContacts(): void {
        const message = JSON.stringify({
          command: 'contacts',
          data: { count: this.giftReceiverLimitCount - this.receivers.length },
        });
        (window as any).ReactNativeWebView.postMessage(message);
      },

      receiveContactsFromArtiseeApp(contactDataFromApp: any): void {
        // JSON String 형태로 데이터가 입력됨.
        // alert(contactDataFromApp.data);

        // JSON String 데이터를 파싱하여 JSON Object 데이터로 변경
        const contactData = JSON.parse(contactDataFromApp.data);
        // alert(contactData);

        // 연락처 목록 JSON Array를 추출
        const contactList = contactData.contactList;
        // alert(typeof(contactList));
        // alert(contactList[0].name);
        // alert(contactList[0].phoneNumber);
        // alert(typeof(contactList[0]));

        if (this.receivers.length + contactList.length > this.giftReceiverLimitCount) {
          this.toggleGiftReceiverLimitPopup();
          return;
        }

        // 하나라도 중복된 연락처 또는 유효하지 않은 연락처가 있다면,
        // 팝업을 띄우고 선택한 모든 연락처가 추가되지 않음.
        const isValidContactList = contactList.every((contact: AddressForArtisee) => {
          const newReceiver = new Receiver({
            receiverName: contact.name,
            receiverTelNo: this.removeHyphen(contact.phoneNumber),
            ticketCount: 1,
          });

          if (!newReceiver.isValidPhoneNumber) {
            this.toggleInvalidPhoneNumberPopup();
            return false;
          }

          if (this.isAddedReceiver(newReceiver)) {
            this.duplicatePhoneNumber = newReceiver.receiverTelNo;
            this.toggleAlreadyAddedPhoneNumberPopup();
            return false;
          }
          return true;
        });

        if (!isValidContactList) {
          return;
        }

        contactList.forEach((contact: AddressForArtisee) => {
          const newReceiver = new Receiver({
            receiverName: contact.name,
            receiverTelNo: this.removeHyphen(contact.phoneNumber),
            ticketCount: 1,
          });
          this.addReceiver(newReceiver);
        });
      },
      removeHyphen(phoneNumber: string): string {
        return phoneNumber.split('-').join('');
      },
      goToWriteMessage(): void {
        router.push(new NamedRouting( 'MessageWritingForPresent'));
      },
      ...mapMutations('ReceiverStore', [
          'addReceiver',
          'removeReceiver'
      ]),
      initInputStatus(): void {
        this.isTypingMode = true;
        this.isDelBtn = false;
      },

      openReceiverInput(): void {
        this.showReceiverInput = true;
        const fakeInput = document.createElement('input');
        fakeInput.setAttribute('type', 'text');
        fakeInput.setAttribute('readonly', 'readonly');
        fakeInput.style.position = 'absolute';
        fakeInput.style.opacity = '0';
        fakeInput.style.height = '0';
        fakeInput.style.fontSize = '16px';
        document.body.prepend(fakeInput);
        fakeInput.focus();
        
        setTimeout(() => {
          this.setAutofocus();
          (this.$refs.phoneNumber as HTMLElement).focus();
          this.isTypingMode = true;
          fakeInput.remove();
        }, 300)
      },

      setAutofocus(): void {
        (this.$refs.phoneNumber as HTMLElement).autofocus = true;
      },

      addNewReceiverForFocusOut(): void {
        if (!this.hasInputPhoneNumber || this.isKeyupEvent) {
          this.isTypingMode = false;
          this.isKeyupEvent = false;
          return;
        }
        setTimeout(() => {
          if(!this.isDelBtn) {
            this.addNewReceiver();
          }
        }, 100)
      },

      addNewReceiverForEnterKey(): void {
        this.isKeyupEvent = true;
        setTimeout(() => {
          this.addNewReceiver();
        }, 100)
      }
    },
  });

  // TODO: Address 형식을 하나로 통일할 것 이왕이면 AdressForArtisee 객체 형태로 요청
  interface Address {
    name: string;
    phonenumber: string;
  }

  interface AddressForArtisee {
    name: string;
    phoneNumber: string;
  }

